var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 32,
    viewBox: "0 0 114 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26109 19.1269L-0.000111081 10.8657L0.539062 10.3265L8.80027 18.5877L8.26109 19.1269Z",
    fill: "#219653"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8495 0.539111L8.26183 19.1268L7.72266 18.5876L26.3104 -6.30707e-05L26.8495 0.539111Z",
    fill: "#219653"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26109 21.7086L-0.000111081 13.4474L0.539062 12.9082L8.80027 21.1694L8.26109 21.7086Z",
    fill: "#219653"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8495 3.12078L8.26183 21.7085L7.72266 21.1693L26.3104 2.5816L26.8495 3.12078Z",
    fill: "#219653"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26109 24.2901L-0.000111081 16.0289L0.539062 15.4897L8.80027 23.751L8.26109 24.2901Z",
    fill: "#219653"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8495 5.70244L8.26183 24.2902L7.72266 23.751L26.3104 5.16327L26.8495 5.70244Z",
    fill: "#219653"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26109 26.8718L-0.000111081 18.6106L0.539062 18.0714L8.80027 26.3326L8.26109 26.8718Z",
    fill: "#219653"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8495 8.28411L8.26183 26.8718L7.72266 26.3326L26.3104 7.74493L26.8495 8.28411Z",
    fill: "#219653"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26109 29.4535L-0.000111081 21.1922L0.539062 20.6531L8.80027 28.9143L8.26109 29.4535Z",
    fill: "#219653"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8495 10.8656L8.26183 29.4534L7.72266 28.9142L26.3104 10.3265L26.8495 10.8656Z",
    fill: "#219653"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26109 31.9782L-0.000111081 23.717L0.539062 23.1779L8.80027 31.4391L8.26109 31.9782Z",
    fill: "#219653"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8495 13.3906L8.26183 31.9783L7.72266 31.4391L26.3104 12.8514L26.8495 13.3906Z",
    fill: "#219653"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7682 13.8034L49.8773 19.5999L47.9863 13.8034H46.019L44.1281 19.5999L42.2371 13.8034H39.8496L43.154 22.7966H45.0067L46.9931 16.6535L49.0751 22.7966H50.9469L54.1557 13.8034H51.7682Z",
    fill: "#111111"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8351 18.2133C63.8351 15.4018 61.8296 13.6109 59.2702 13.6109C56.7298 13.6109 54.5906 15.421 54.5906 18.2904C54.5906 21.1019 56.6152 22.9891 59.2893 22.9891C60.9128 22.9891 62.479 22.2959 63.3003 20.9864L61.8296 19.8502C61.2948 20.582 60.378 20.9671 59.4039 20.9671C58.0859 20.9671 57.1309 20.3316 56.8826 19.0799H63.7778C63.816 18.7525 63.8351 18.4637 63.8351 18.2133ZM56.8826 17.5201C57.15 16.1528 58.105 15.5751 59.3084 15.5751C60.5499 15.5751 61.4858 16.2876 61.6195 17.5201H56.8826Z",
    fill: "#111111"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7667 22.9699C71.3138 22.9699 72.5744 22.2766 73.3957 21.2367L71.8104 19.985C71.352 20.5435 70.588 20.8901 69.8049 20.8901C68.2577 20.8901 67.1499 19.7924 67.1499 18.2904C67.1499 16.7691 68.2577 15.6906 69.8049 15.6906C70.588 15.6906 71.352 16.0373 71.8104 16.5957L73.3957 15.344C72.5744 14.2849 71.3138 13.6109 69.7667 13.6109C67.1881 13.6109 64.9152 15.4403 64.9152 18.2904C64.9152 21.1404 67.1881 22.9699 69.7667 22.9699Z",
    fill: "#111111"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8836 13.6109C78.9859 13.6109 77.5533 14.0923 77.114 15.1707V8.98914H74.8984V22.7966H77.114V18.0978C77.114 16.3647 78.3746 15.8062 79.387 15.8062C80.3802 15.8062 81.2397 16.538 81.2397 17.963V22.7966H83.4553V17.7512C83.4553 15.1322 82.1756 13.6109 79.8836 13.6109Z",
    fill: "#111111"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2867 18.2133C94.2867 15.4018 92.2812 13.6109 89.7217 13.6109C87.1814 13.6109 85.0421 15.421 85.0421 18.2904C85.0421 21.1019 87.0668 22.9891 89.7408 22.9891C91.3644 22.9891 92.9306 22.2959 93.7519 20.9864L92.2812 19.8502C91.7464 20.582 90.8295 20.9671 89.8554 20.9671C88.5375 20.9671 87.5825 20.3316 87.3342 19.0799H94.2294C94.2676 18.7525 94.2867 18.4637 94.2867 18.2133ZM87.3342 17.5201C87.6016 16.1528 88.5566 15.5751 89.7599 15.5751C91.0014 15.5751 91.9374 16.2876 92.0711 17.5201H87.3342Z",
    fill: "#111111"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M100.218 22.9699C101.765 22.9699 103.026 22.2766 103.847 21.2367L102.262 19.985C101.804 20.5435 101.04 20.8901 100.256 20.8901C98.7093 20.8901 97.6015 19.7924 97.6015 18.2904C97.6015 16.7691 98.7093 15.6906 100.256 15.6906C101.04 15.6906 101.804 16.0373 102.262 16.5957L103.847 15.344C103.026 14.2849 101.765 13.6109 100.218 13.6109C97.6397 13.6109 95.3668 15.4403 95.3668 18.2904C95.3668 21.1404 97.6397 22.9699 100.218 22.9699Z",
    fill: "#111111"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M113.85 22.7966L109.38 17.7319L113.009 13.8034H110.125L107.566 16.6728V8.98914H105.35V22.7966H107.566V18.714L111.042 22.7966H113.85Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f8a2d0702f5c3082aac4673f2fd09373.svg";
export { ForwardRef as ReactComponent };